import { compose, lifecycle, withStateHandlers } from 'recompose';
import { injectIntl } from 'react-intl';
import {
  addIntlProps,
  addProps,
  renderNothingIfPropFalsy,
} from 'utils/recompose';
import messages from './messages';
import { connect } from 'react-redux';
import combineSelectors from 'utils/combineSelectors';
import formatCurrencyGeneral from 'utils/formatCurrencyGeneral';
import {
  competitionData,
  competitionCompModelCodes,
  compModelCode,
} from 'reducers/modelCompetition/selectors';
import {
  clearModelCompetitionData,
  fetchModelCompetition,
} from 'reducers/modelCompetition/actions';
import { modelCompetitionLoaded } from 'reducers/loading/selectors';
import styles from './styles.module.scss';

const mapStateToProps = combineSelectors({
  competitionData,
  competitionCompModelCodes,
  compModelCode,
  modelCompetitionLoaded,
});

const mapDispatchToProps = { clearModelCompetitionData, fetchModelCompetition };

export async function componentDidMount() {
  this.props.clearModelCompetitionData();
  await this.props.fetchModelCompetition({ modelId: this.props.modelId });
  if (
    this.props.compModelCode === '' &&
    this.props.competitionCompModelCodes.length > 0
  ) {
    this.props.fetchModelCompetition({
      modelId: this.props.modelId,
      compModel: this.props.competitionCompModelCodes[0].code,
    });
  }
}

export const initialState = { showCompetition: true, showOwn: true };

export const toggleCompetitionArea = ({ showCompetition }) => () => ({
  showCompetition: !showCompetition,
});

export const toggleOwnLine = ({ showOwn }) => () => ({
  showOwn: !showOwn,
});

export const resetFilters = ({ showCompetition, showOwn }) => () =>
  initialState;

export const selectedTemplateStyle = ({ showOwn }) =>
  showOwn ? styles.inactiveFilter : styles.activeFilter;

export const competitionStyle = ({ showCompetition }) =>
  showCompetition ? styles.inactiveFilter : styles.activeFilter;

export const ownData = ({ competitionData }) => {
  const own =
    competitionData && competitionData.filter(data => data.type === 'own');
  return own && own.length > 0 ? own[0] : null;
};

export const competitorData = ({ competitionData }) => {
  const competitor =
    competitionData &&
    competitionData.filter(data => data.type === 'competition');
  return competitor && competitor.length > 0 ? competitor[0] : null;
};

const formatPriceBucketLabel = (priceBucketData, currency, intl) => {
  let min = formatCurrencyGeneral(priceBucketData.min, currency, intl);
  let max = formatCurrencyGeneral(priceBucketData.max, currency, intl);
  return `PB${priceBucketData.id} ${min} - ${max}`;
};

export const formatPriceBucketPercent = pbPercent => {
  return Math.round(pbPercent * 100) / 100;
};

export const data = ({
  currency,
  intl,
  competitionData,
  ownData,
  competitorData,
}) => {
  let compData =
    ownData &&
    ownData.priceBuckets.reduce((obj, data) => {
      obj[data.priceBucket.id] = {
        own: formatPriceBucketPercent(data.percent),
        priceBucketLabel: formatPriceBucketLabel(
          data.priceBucket,
          currency,
          intl,
        ),
      };
      return obj;
    }, {});

  competitorData &&
    competitorData.priceBuckets.forEach(data => {
      if (compData[data.priceBucket.id]) {
        compData[data.priceBucket.id].competition = formatPriceBucketPercent(
          data.percent,
        );
      } else {
        compData[data.priceBucket.id] = {
          competition: formatPriceBucketPercent(data.percent),
          priceBucketLabel: formatPriceBucketLabel(
            data.priceBucket,
            currency,
            intl,
          ),
        };
      }
    });
  return compData ? Object.values(compData) : [];
};

export default compose(
  injectIntl,
  addIntlProps({
    messages,
    propNames: [
      'currency',
      'selectedTemplatesLabel',
      'competitorDistributionLabel',
      'clearFiltersLabel',
    ],
  }),
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  lifecycle({ componentDidMount }),
  withStateHandlers(initialState, {
    toggleOwnLine,
    toggleCompetitionArea,
    resetFilters,
  }),
  addProps({
    ownData,
    competitorData,
    selectedTemplateStyle,
    competitionStyle,
  }),
  addProps({
    data,
  }),
  renderNothingIfPropFalsy('modelCompetitionLoaded'),
);
